export const SECONDS_IN_YEAR = 3.154e7;
export const SECONDS_IN_DAY = 86400;
